import { Breadcrumbs, Link } from '@mui/material';
import React from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { slugify } from '@/utils/stringConvert';
import { style } from '@/styles/globals';

const BreadcrumbSeo: React.FC<{ sx?: React.CSSProperties; breadcrumbs: { title: string, url: string }[] }> = (props) => {
  const { breadcrumbs, sx } = props;
  const finalIndex: number = breadcrumbs.length - 1;
  return (
    <Breadcrumbs
      sx={{ ...sx }}
      aria-label="breadcrumb"
      separator={(
        <KeyboardArrowRightIcon
          htmlColor={style.color.product3}
          fontSize="small"
        />
  )}
      maxItems={5}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <Link
          key={index}
          sx={{
            fontWeight: 500,
          }}
          underline={index === finalIndex ? 'none' : 'always'}
          color={index === finalIndex ? style.color.black1 : style.color.product3}
          href={breadcrumb.url}
        >
          {breadcrumb.title}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default React.memo(BreadcrumbSeo);
